import { FormattedMessage } from 'react-intl';
import { ScreenWrapper } from '../../atoms/ScreenWrapper/ScreenWrapper';
import { ContentBody } from '../../atoms/ContentBody/ContentBody';
import { Text } from '../../atoms/Text/Text';
import { usePageViewEvents } from '../../../core/Analytics/usePageViewEvents';
import { PageView } from '../../../models/analytics';
import { messages } from './messages';

export const FlowFinished = () => {
  usePageViewEvents({ pageView: PageView.FLOW_FINISHED_SCREEN });

  return (
    <ScreenWrapper>
      <ContentBody centerHorizontally centerVertically>
        <Text>
          <FormattedMessage {...messages.doneHere} />
        </Text>
      </ContentBody>
    </ScreenWrapper>
  );
};
